var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.885 18.98C34.1193 19.2144 34.251 19.5323 34.251 19.8637C34.251 20.1952 34.1193 20.5131 33.885 20.7475L29.1975 25.435L27.43 23.6675L29.845 21.25H18.75V18.75H30.12L27.43 16.06L29.1975 14.2925L33.885 18.98ZM23.75 7.5C24.0815 7.5 24.3995 7.6317 24.6339 7.86612C24.8683 8.10054 25 8.41848 25 8.75V12.84H22.5V10H7.49999V30H22.5V27.16H25V31.25C25 31.5815 24.8683 31.8995 24.6339 32.1339C24.3995 32.3683 24.0815 32.5 23.75 32.5H6.24999C5.91847 32.5 5.60053 32.3683 5.36611 32.1339C5.13169 31.8995 4.99999 31.5815 4.99999 31.25V8.75C4.99999 8.41848 5.13169 8.10054 5.36611 7.86612C5.60053 7.6317 5.91847 7.5 6.24999 7.5H23.75Z",
    fill: "#091540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.94194927508312afd81a1d957bbf57d3.svg";
export { ForwardRef as ReactComponent };